import { OperatorPanelWrapperFullSize } from '../../components/Layout'
import { IBacnetDevice } from './types';
import { InfoPanel } from './InfoPanel';



export const OperatorPanel = (props: IBacnetDevice) => {

  return (
    <OperatorPanelWrapperFullSize
      objectId={props.id}
      resourceGroupId={props.resourceGroupId}
      statusContent={
        <InfoPanel {...props}></InfoPanel>
      }
    >
    </OperatorPanelWrapperFullSize>
  )
} 